<template>
  <FamilyDrawerHeader sub-title="Ny kund anpassa extra mobilabonnemang" />
  <div
    class="px-16 md:px-24"
    :class="{ 'pt-24 md:pt-32': !familyStore.ui.isProductPage }"
  >
    <FamilyPdpGoBack v-if="familyStore.ui.isProductPage" class="pb-32" />
    <FamilyDiscountLabels :existing-customer="false" :in-drawer="true" />
    <FamilySectionDataAllowance />
    <FamilySectionBindPeriod v-if="!familyStore.ui.isProductPage" />
    <FamilySectionAddFamily />
    <div
      v-if="
        familyStore.selectedParentPlanBundlePrice?.Discounts?.filter(
          (discount) => discount.Description.length > 0,
        ) &&
        familyStore.selectedParentPlanBundlePrice?.Discounts?.filter(
          (discount) => discount.Description.length > 0,
        ).length > 0
      "
      class="md:pr-12 order-9 mb-24 mt-24 flex flex-col gap-24"
    >
      <template
        v-for="discount in familyStore.selectedParentPlanBundlePrice?.Discounts"
        :key="discount.DiscountId"
      >
        <InfoCard
          v-if="discount.Description.length > 0"
          :header-class="discount.LabelColor"
          padding-x="px-16"
        >
          <template #header>
            <div class="flex gap-16 items-center">
              <nuxt-icon
                name="gift"
                class="text-[3.2rem] mb-0"
                aria-hidden="true"
              />
              <p class="heading-xs text-inherit">
                {{ discount.LabelText }}
              </p>
            </div>
          </template>
          <MarkupGenerator
            v-if="campaignMarkup(discount.Description) !== null"
            :is-page="false"
            :page-data="campaignMarkup(discount.Description) as any"
          />
        </InfoCard>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MarkupData } from '~/repository/modules/category.module';
const familyStore = useFamilyStore();

const campaignMarkup = (discountMarkup: any) => {
  const bodyMarkup = ref<MarkupData | null>(null);
  if (discountMarkup) {
    bodyMarkup.value = {
      PageContent: discountMarkup,
    };
  }
  return bodyMarkup.value;
};
</script>

<style scoped></style>
